module.exports = __webpack_public_path__ + "media/images/logos/facebook-43bb0f3a01a1a8c7f1083be7c8bcc0a9.svg";